const formatDateTime = (fullYear: boolean, dateString?: Date | null): string => {
    if (!dateString) {
        return ''
    }

    let hours = dateString?.getHours() || 0
    let minutes = dateString?.getMinutes() || ''
    const ampm = hours >= 12 ? 'pm' : 'am'
    hours %= 12
    hours = hours || 12 // the hour '0' should be '12'
    minutes = typeof minutes === 'string' ? '00' : minutes < 10 ? `0${minutes}` : minutes
    const strTime = `${hours}:${minutes} ${ampm}`
    const shortYear = dateString.getFullYear().toString().substr(-2)
    if (fullYear === true) {
        return `${dateString?.getMonth() + 1}/${dateString.getDate()}/${dateString.getFullYear()} ${strTime}`
    }

    return `${dateString?.getMonth() + 1}/${dateString.getDate()}/${shortYear} ${strTime}`
}

export default formatDateTime
